const { WEB_ENV } = process.env

const TB_URL = {
  beta: 'http://salesdemo.teambition.net',
  release: 'https://tb.tfzq.com',
}[WEB_ENV]

const HOST = {
  beta: 'http://139.196.210.102:3032',
  release: 'http://ai.sjtu.edu.cn/api',
}[WEB_ENV]

export {
  TB_URL,
  HOST
}



// WEBPACK FOOTER //
// ./src/utils/config.js